var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('promo-sales-timed',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_phasesInfo = ref.phasesInfo;
var currentPhase = ref_phasesInfo.currentPhase;
var annualSalesPhases = ref_phasesInfo.annualSalesPhases;
var timeZone = ref_phasesInfo.timeZone;
return [_c('promo-sale-phase-2',{attrs:{"current-phase":currentPhase,"phases":annualSalesPhases,"time-zone":timeZone}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }